import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import PositionFundApprovalsTableRow from './PositionFundApprovalsTableRow';
import PositionFundApprovalsViewModal from './PositionFundApprovalsViewModal';

import { modalOptions } from 'Helpers/modalOptions';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

function PositionFundApprovalsTable(props) {
    const [positionFundApprovals, setPositionFundApprovals] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [viewedPFA, setViewedPFA] = useState({});

    const [positionFundApprovalsViewModalElement, setPositionFundApprovalsViewModalElement] = useState(null);

    const positionFundApprovalsViewModalRef = useRef();

    useEffect(() => {
        fetchPositionFundApprovals();
        positionFundApprovalsViewModalRef &&
            setPositionFundApprovalsViewModalElement(new Modal(positionFundApprovalsViewModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        if (Object.keys(viewedPFA).length > 0) {
            positionFundApprovalsViewModalElement && positionFundApprovalsViewModalElement.show();
        }
    }, [viewedPFA]);
    const viewPFA = (pfa) => {
        setViewedPFA({ ...pfa });
    };

    const defaultUrl = props.fetchPositionFundApprovalsUrl + '?per_page=' + perPage;

    const combineFetchUrl = (p = null, pp = null) => {
        return props.fetchPositionFundApprovalsUrl + '?per_page=' + (pp || perPage) + '&page=' + (p || page);
    };

    const fetchPositionFundApprovals = (url = null) => {
        const fetchUrl = url || defaultUrl;

        axios
            .get(fetchUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                setPositionFundApprovals(data);
                setTo(to);
                setFrom(from);
                setTotal(total);
                setLastPage(last_page);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchPositionFundApprovals(url);
    }

    const resetData = () => {
        positionFundApprovalsViewModalElement && positionFundApprovalsViewModalElement.hide();
    };

    return (
        <div>
            <div className="table__pagination-info tw-mb-6">
                <PaginationInfo to={to} from={from} total={total} />
                <TablePagination lastPage={lastPage} pageChange={pageChange} />
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>Staff</th>
                            <th>Position</th>
                            <th>Status</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {positionFundApprovals.map((positionFundApproval) => {
                            return (
                                <PositionFundApprovalsTableRow
                                    key={positionFundApproval.id}
                                    positionFundApproval={positionFundApproval}
                                    clickHandler={() => viewPFA(positionFundApproval)}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <PositionFundApprovalsViewModal
                modalId={'view-pfa'}
                modalRef={positionFundApprovalsViewModalRef}
                modalElement={positionFundApprovalsViewModalElement}
                closeHandler={resetData}
                successHandler={resetData}
                pfa={viewedPFA}
                displayApprovalStatuses={props.displayApprovalStatuses}
            />
        </div>
    );
}

export default PositionFundApprovalsTable;
